import './SpiderGraph.css';
import Radar from 'react-d3-radar'
import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import SliderCoeff from './SliderCoeff';


import './Calibrate.css';

function Calibrate(props) {

    async function handleClick()
    {
        if (props.muse1 !== undefined)
        {
            console.log('--onClick--')
            props.muse1.calibrate();
        }

        if (props.muse2 !== undefined)
        {
            props.muse2.calibrate();
        }

    }

    return (
            <div id="containerCalibrate">
                <SliderCoeff muse1={props.muse1} muse2={props.muse2}/>
                <Button variant="outlined" onClick={handleClick}>Calibrate</Button>
            </div>
    )
}

export default Calibrate;